import React from "react";

export default function ModerationOverlay () {
    return (
    <div className="moderation-overlay">
        <div className="moderation-popup">
            <p className="R14_61">Thanks for submitting your answer. The submission is under review, you can view status in My account->My answers</p>
            <a href="https://parenting.firstcry.ae/my-account/myanswers" className="M15_pink right">OK</a>
        </div>
    </div>
    );
}


// WEBPACK FOOTER //
// src/shared/qna/common/ModerationOverlay.js